import { graphql } from '@teachino/shared-infrastructure';
import { courseBadgeFragment } from './course-badge.fragment';

export const topicFragment = graphql(
  `
    fragment Topic on Folder {
      id
      __typename
      name
      topicCourses {
        ...CourseBadge
      }
    }
  `,
  [courseBadgeFragment],
);
